export var VertexBufferType;
(function (VertexBufferType) {
    VertexBufferType[VertexBufferType["MORTON"] = 0] = "MORTON";
    VertexBufferType[VertexBufferType["VEC_2"] = 1] = "VEC_2";
    VertexBufferType[VertexBufferType["VEC_3"] = 2] = "VEC_3";
})(VertexBufferType || (VertexBufferType = {}));
//# sourceMappingURL=vertexBufferType.js.map